/** @typedef {'ladies' | 'gents'} PosGender */

/** @typedef {'ladies' | 'gents' | 'all'} PosCatalogGenderFilter */

export const POS_GENDER_TOGGLE_OPTIONS = [
  { value: 'ladies', label: 'L', title: 'Ladies' },
  { value: 'gents', label: 'G', title: 'Gents' },
  { value: 'all', label: 'All', title: 'All categories' },
]

/**
 * @param {number | string | null | undefined} value
 */
export function toPosAmount(value) {
  if (value === null || value === undefined || value === '') return 0
  const parsed = Number(value)
  return Number.isFinite(parsed) ? parsed : 0
}

/**
 * @param {PosCatalogGenderFilter} catalogFilter
 * @param {PosGender | string | null | undefined} saleGenderPrice
 * @returns {PosGender}
 */
export function resolvePosPricingGender(catalogFilter, saleGenderPrice) {
  if (catalogFilter === 'ladies' || catalogFilter === 'gents') {
    return catalogFilter
  }

  if (saleGenderPrice === 'ladies' || saleGenderPrice === 'gents') {
    return saleGenderPrice
  }

  return 'ladies'
}

/**
 * @param {PosCatalogGenderFilter} catalogFilter
 */
export function shouldUpdateSaleGenderPrice(catalogFilter) {
  return catalogFilter === 'ladies' || catalogFilter === 'gents'
}

/**
 * @param {import('@/types/api').ServiceCategory[]} categories
 * @param {PosCatalogGenderFilter} filter
 */
export function filterCategoriesForPos(categories, filter) {
  return categories
    .filter((category) => category.is_active)
    .filter((category) => {
      if (filter === 'all') return true
      if (category.gender_scope === 'all') return true
      return category.gender_scope === filter
    })
    .sort((left, right) => {
      const sortDelta = (left.sort ?? 0) - (right.sort ?? 0)
      return sortDelta !== 0 ? sortDelta : left.name.localeCompare(right.name)
    })
}

/**
 * @param {import('@/types/api').Service[]} services
 */
export function filterActiveServices(services) {
  return services.filter((service) => service.is_active)
}

/**
 * @param {import('@/types/api').Service} service
 * @param {PosGender} gender
 */
export function resolveServicePrice(service, gender) {
  return gender === 'gents'
    ? toPosAmount(service.price_gents)
    : toPosAmount(service.price_ladies)
}

/**
 * @param {import('@/types/api').Service} service
 * @param {PosGender} gender
 */
export function formatServicePrice(service, gender) {
  const amount = resolveServicePrice(service, gender)
  return `AED ${amount.toLocaleString(undefined, { maximumFractionDigits: 0 })}`
}

/**
 * @param {number} duration
 */
export function formatDurationBadge(duration) {
  if (!duration || duration <= 0) return null
  return `${duration} min`
}

/**
 * @param {import('@/types/api').ServiceCategory | null | undefined} category
 */
export function getCategoryAccentColour(category) {
  return category?.colour ?? '#7C3AED'
}
